import { EntitySetName, EntityTypeName, PrImprisonmentEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { setDefByEntityType } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import ImprisonmentFormView from "@pages/payroll/socialEvents/eventTypes/ImprisonmentFormView";
import { SocialEventGroup } from "@pages/payroll/socialEvents/SocialEvents.types";
import i18next from "i18next";
import { cloneDeep } from "lodash";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import { BasicInputSizes, FieldType } from "../../../../enums";
import { addFormDef, getFormGroup } from "../../../../views/formView/Form.utils";
import { getDefinitions as commonDef, getSocialEventsFormDef } from "../SocialEventsDef";

export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const d = cloneDeep(getSocialEventsFormDef(ImprisonmentFormView, PrSocialEventTypeCode.Imprisonment, context));
    const generalGroup = getFormGroup(d, SocialEventGroup.General);

    addFormDef(d, PrImprisonmentEventEntity.DateEventStart, {
        type: FieldType.Date,
        width: BasicInputSizes.L,
        label: i18next.t("SocialEvents:Form.DateOfEntry"),
    });

    addFormDef(d, PrImprisonmentEventEntity.DateEventEnd, {
        type: FieldType.Date,
        isRequired: true,
        width: BasicInputSizes.L,
        label: i18next.t("SocialEvents:Form.ExpectedTermination"),
    });

    generalGroup.rows = [[
        { id: PrImprisonmentEventEntity.Employee },
        { id: PrImprisonmentEventEntity.Employment },
    ], [
        { id: PrImprisonmentEventEntity.DateEventStart },
        { id: PrImprisonmentEventEntity.DateEventEnd }
    ]];

    return {
        ...d,
        entitySet: EntitySetName.PrImprisonmentEvents
    };
};

getDefinitions.translationFiles = [
    ...commonDef.translationFiles,
    getEnumNameSpaceName(EntityTypeName.PrImprisonmentEvent)
];
setDefByEntityType(EntityTypeName.PrImprisonmentEvent, getDefinitions);